import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import { Baby } from "lucide-react";
import type { MarriageProfileDto } from "src/types/Profile";
import type { FamilyBackground } from "src/types/matrimonyProfileDetails";
import InfoCard from "../InfoCard";
import KeyValueRow from "../KeyValueRow";
import EditButton from "../EditButton";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";

type FamilySectionProps = {
  family: FamilyBackground;
  dto: MarriageProfileDto;
  isOwnProfile: boolean;
  onEdit: () => void;
};

const FamilySection: React.FC<FamilySectionProps> = ({ family, dto, isOwnProfile, onEdit }) => (
  <InfoCard
    title="Family Background"
    icon={<Baby size={18} />}
    rightSlot={isOwnProfile ? <EditButton onClick={onEdit} /> : null}
  >
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
      <KeyValueRow label={FIELD_LABELS.FATHER_NAME} value={family.fatherName} />
      <KeyValueRow label={FIELD_LABELS.MOTHER_NAME} value={family.motherName} />
      <KeyValueRow label={FIELD_LABELS.FATHER_OCCUPATION} value={family.fatherStatus} />
      <KeyValueRow label={FIELD_LABELS.MOTHER_OCCUPATION} value={family.motherStatus} />
      <KeyValueRow label={FIELD_LABELS.FAMILY_TYPE} value={family.familyType} />
      <KeyValueRow label={FIELD_LABELS.FAMILY_STATUS} value={dto.familyStatus || ""} />
      <KeyValueRow
        label={FIELD_LABELS.TOTAL_FAMILY_MEMBERS}
        value={dto.totalFamilyMembers != null ? String(dto.totalFamilyMembers) : ""}
      />
    </SimpleGrid>
  </InfoCard>
);

export default FamilySection;
